import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Fragment } from "react/jsx-runtime";
import Routers from "./routers/RouterProvider";
import 'bootstrap/dist/css/bootstrap.min.css';  // Import Bootstrap CSS
import { useEffect } from "react";
import { useAppDispatch } from "./reduxToolkit/hooks";
import { login } from "./reduxToolkit/reducers/layout/authSlice";

const App = () => {

   const dispatch = useAppDispatch();
    useEffect(()=>{
         const token = sessionStorage.getItem('Auth-Token')

         if(token){
           dispatch(login(token))
         }
    },[])
  
  return (
    <Fragment>
      <RouterProvider router={Routers} />
      <ToastContainer />
    </Fragment>
  );
};

export default App;
